export default {
  locale: "en-US",

  shopping_cart: "Shopping Cart",
  cart: "Cart",
  product: "Product",
  products: "Products",
  order: "Order",
  price: "Price",
  quantity: "Quantity",
  payment: "Payment",
  name: "Name",
  email: "Email",
  phone: "Phone",
  delivery: "Delivery",
  shipping: "Shipping",
  address: "Address",
  city: "City",
  country: "Country",
  state: "State",
  region: "Region",
  province: "Province",
  prefecture: "Prefecture",
  governorate: "Governorate",
  county: "County",
  emirate: "Emirate",
  pin_code: "PIN Code",
  zip_code: "ZIP Code",
  postcode: "Postal Code",
  shipping_method: "Shipping Method",
  shipping_address: "Shipping Address",
  pickup_at_store: "Pickup at Store",
  store: "Store",
  working_hours: "Working Hours",
  billing: "Billing",
  billing_name: "Billing Name",
  billing_address: "Billing Address",
  note_to_seller: "Note",
  total: "Total",
  subtotal: "Subtotal",
  price_free: "Free",
  credit_card: "Credit Card",
  pay_on_pickup: "Pay on Pickup",
  out_of_stock: "Out of Stock",
  and: "and",
  date: "date",
  status: "status",

  apply: "Apply",
  remove: "Remove",
  clear: "Clear",
  close: "Close",
  error: "Error",
  required: "Required",

  "cart.checkout": "Checkout",
  "cart.back_to_cart": "Back to Cart",
  "cart.update": "Update Cart",
  "cart.complete_order": "Complete Order",
  "cart.terms_agree": "I agree to the {terms}",
  "cart.terms_of_service": "Terms & Conditions",
  "cart.privacy_policy": "Privacy Policy",
  "cart.refund_policy": "Refund Policy",
  "cart.customer_details": "Customer Details",
  "cart.subtotal_only": "Shipping and taxes are calculated during checkout.",
  "cart.pickup_at_store": "Pick up at {store}",
  "cart.order_ready_for_pickup_label": "Order Ready for Pickup",
  "cart.estimated_delivery": "Estimated Delivery",
  "cart.select_store": "Select a Store",
  "cart.add_billing": "Add Billing Info",
  "cart.deliver_to_address": "Deliver to Address",
  "cart.shipping_not_selected": "Not yet selected",
  "cart.select_country": "Select Country",
  "cart.note_to_seller": "Note to Seller",
  "cart.note_to_seller_placeholder":
    "If you have any specific instructions you want to give to the seller, write them here.",
  "cart.save_address": "Save my address for future purchases",
  "cart.tax_exemption_add": "Apply a Tax Exemption",
  "cart.tax_exemption_file": "Tax Exemption File",
  "cart.tax_exemption_file_prompt": "Attach a document or photo of your tax exemption",
  "cart.tax_exemption_number_prompt": "Enter your EU VAT number",
  "cart.tax_exemption_cleared": "Tax exemption invalidated",
  "cart.tax_exemption_cleared_details":
    "The provided tax exemption info could not be applied to the newly selected address.",
  "cart.discount_code_placeholder": "Enter coupon or promo code",
  "cart.coupon_added": "Coupon added",
  "cart.coupon_removed": "Coupon removed",
  "cart.gift_card_added": "Gift Card added",
  "cart.gift_card_removed": "Gift Card removed",
  "cart.gift_card_balance": "available balance - {amount}",
  "cart.order_summary": "Order Summary",
  "cart.show_summary": "Show Summary",
  "cart.prices_currency_description": "All prices are in {currency}",
  "cart.left_in_stock":
    "{in_stock, plural, =0 {0 items left in stock} other {Only # left in stock.}}",
  "cart.max_product_qty": "Maximum of {max_quantity} per customer",
  "cart.errors.unavailable": "Unable to load shopping cart.",
  "cart.errors.empty": "Your shopping cart is empty.",
  "cart.errors.no_payment_methods": "This store has no payment methods configured.",
  "cart.errors.only_paypal_no_delivery":
    "This store offers only PayPal payments but does not support product delivery. Checkout unavailable.",
  "cart.errors.cannot_complete": "Couldn't complete checkout.",
  "cart.errors.vat_number_invalid":
    "VAT number is invalid or can't be used in cross-border transactions.",
  "cart.errors.vat_number_validation_fail": "VAT could't be validated.",
  "cart.errors.delivery_unavailable": "Product delivery is not available. Please contact us.",
  "cart.errors.address_not_supported": "The store is unable to ship your order to this address.",
  "cart.errors.invalid_discount_code": "The code you entered is not valid.",
  "cart.errors.coupon_invalid_code": "The code you entered is not valid.",
  "cart.errors.coupon_already_applied": "Only one coupon can be applied.",
  "cart.errors.gift_card_already_applied": "Only one gift card can be applied.",
  "cart.errors.cannot_apply_gift_card_to_cart_with_giftcard":
    "The gift card cannot be applied to the cart. There is a gift card product being purchased",
  "cart.errors.coupon_no_matching_products":
    "Coupon cannot be applied to any of the products in the cart.",
  "cart.errors.coupon_min_amount": "Coupon requires a minimum order amount of {amount}.",
  "cart.errors.coupon_expired": "Coupon has expired.",
  "cart.errors.out_of_stock": "One or more products are out of stock.",
  "cart.errors.unavailable_quantity":
    "Only {available} {product} available in the store. There {in_cart, plural, =1 {is} other {are}} {in_cart} in your cart.",
  "cart.errors.invalid_coupon":
    "Invalid coupon in cart. Please remove the coupon to continue with checkout.",
  "cart.errors.cannot_ship": "The products cannot be shipped to the provided address.",
  "cart.errors.min_val_not_reached": "The minimum product value for placing an order is {min_val}.",
  "cart.errors.max_val_exceeded": "Cart value exceeds supported limits.",
  "cart.errors.product_min_qty_not_reached":
    "The minimum purchase amount for {product} is at least {min_qty}. There {in_cart, plural, =1 {is} other {are}} {in_cart} in your cart.",
  "cart.errors.product_max_qty_exceeded":
    "A maximum of {max_qty} {product} can be purchased per customer. {in_cart, plural, =0 {} =1 {There is 1 already in your cart.} other {There are # already in your cart.}}",

  "product.left_in_stock": "{numberItems} left in stock",
  "product.missing": "This product doesn't exist.",
  "product.out_of_stock": "Product is out of stock.",
  "product.unavailable_quantity": "Not enough items in stock.",
  "product_list.empty": "No products found",

  "product_search.button": "Search",
  "product_search.placeholder": "Search Products",

  "add_to_cart.button_text": "Add to Cart",
  "add_to_cart.success": "Product added to cart.",
  "add_to_cart.error": "Couldn't add product to cart",
  "add_to_cart.see_cart": "See Cart",
  "add_to_cart.min_quantity_per_order": "Minimum Per Order is {quantity}",

  "order_status.order": "Order #{orderId}",
  "order_status.status": "Status",
  "order_status.created": "Created",
  "order_status.order_summary": "Order Summary",
  "order_status.product_personalizations": "Personalizations",
  "order_status.customer_details": "Customer Details",
  "order_status.processed": "processed",
  "order_status.pending": "pending",
  "order_status.shipped": "shipped",
  "order_status.ready_for_pickup": "ready for pickup",
  "order_status.received": "received",
  "order_status.refunded": "refunded",
  "order_status.cancelled": "cancelled",
  "order_status.payment_failed": "payment failed",
  "order_status.check_email": "Please check your email for order confirmation.",

  "auth.sign_in": "Sign In",
  "auth.sign_out": "Sign Out",
  "auth.register": "Register",
  "auth.prompt_register": "Don't have an account?",

  "user_orders.sign_in_prompt": "Sign in to view your orders",
  "user_orders.empty": "No orders found",

  "user_settings.user_settings": "User Settings",
  "user_settings.sign_in_prompt": "Sign in to view your profile",
  "user_settings.profile_update_success": "Profile Updated",
  "user_settings.profile_update_failed": "Profile Update Failed",
  "user_settings.change_photo": "Change Photo",

  store_unavailable: "The store is temporarily unavailable.",
};
